<template>
  <div class="flex align-center" :class="addClass">
    <div :class="{'input-with-icon': showIcon}">
      <div :class="{'icon': showIcon, 'icon-clock': showIcon}"></div>
      <time-input
        :date="startTime"
        :width="inputWidth"
        @changed="setStartTime">
      </time-input>
    </div>
    <div class="timepicker timepicker-line">
      -
    </div>
    <div :class="{'input-with-icon': showIcon}">
      <div :class="{'icon': showIcon, 'icon-clock': showIcon}"></div>
      <time-input
        :date="endTime"
        :width="inputWidth"
        @changed="setEndTime">
      </time-input>
    </div>
    <input name="event_start" class="none" type="hidden" v-model="utcStart">
    <input name="event_end" class="none" type="hidden" v-model="utcEnd">
  </div>
</template>

<script>
import moment from 'moment'
import timeInput from './timechanger/TimeInput.vue'

export default {
  components: {timeInput},
  props: {
    start: {},
    end: {},
    lang: {},
    addClass: {
      type: String,
      default: ''
    },
    showIcon: {
      type: Boolean,
      default: false
    },
    isFiveMinutesInterval: {
      type: Boolean,
      default: false
    },
    inputWidth: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      diff: 60,
      startTime: moment(this.start),
      endTime: moment(this.end)
    }
  },
  watch: {
    start () {
      this.startTime = moment(this.start)
    },
    end () {
      this.endTime = moment(this.end)
    }
  },
  computed: {
    utcStart () {
      return moment.utc(this.startTime).toISOString()
    },
    utcEnd () {
      return moment.utc(this.endTime).toISOString()
    }
  },
  methods: {
    calcDiff () {
      let _diff = moment(this.endTime).diff(this.startTime)
      this.diff = moment.duration(_diff).asMinutes()
    },
    setStartTime (val) {
      let number = moment(val, 'LT') // check if number
      if (isNaN(number)) {
        this.startTime = this.startTime
        return
      } else {
        let hours = moment(number).format('HH')
        let minutes = this.isFiveMinutesInterval ? Math.round(moment(number).format('mm') / 5) * 5 : moment(number).format('mm')
        let _newDate = moment(this.startTime).set({'hour': hours, 'minute': minutes})
        if (hours * 1 === 23 && minutes * 1 === 55) {
          _newDate = moment(this.startTime).set({'hour': hours, 'minute': 50})
        }
        this.startTime = _newDate
        if (moment(this.endTime).isBefore(_newDate) || moment(this.endTime).isSame(_newDate)) {
          let newEndDate = moment(this.startTime).add(this.diff, 'minutes')
          if (moment(this.startTime).isSame(newEndDate, 'day')) {
            this.endTime = newEndDate
          } else {
            this.endTime = moment(this.startTime).set({'hour': 23, 'minutes': 55})
          }
          this.$emit('updateEnd', this.endTime)
        }
        this.$emit('updateStart', this.startTime)
      }
    },
    setEndTime (val) {
      let number = moment(val, 'LT') // check if number
      if (isNaN(number)) {
        this.endTime = this.endTime
        return
      } else {
        let hours = moment(number).format('HH')
        let minutes = this.isFiveMinutesInterval ? Math.round(moment(number).format('mm') / 5) * 5 : moment(number).format('mm')
        let _newDate = moment(this.endTime).set({'hour': hours, 'minute': minutes})
        if (moment(_newDate).isBefore(this.startTime) || moment(this.startTime).isSame(_newDate)) {
          this.endTime = this.endTime
        } else {
          this.endTime = _newDate
          this.$emit('updateEnd', this.endTime)
        }
      }
    }
  },
  mounted () {
    this.calcDiff()
  }
}
</script>

<style>
@import '../assets/css/variables.css';

.input-warning input {
  border-color: #fa565a !important;
}

.timepicker-line {
  display: inline-block;
  padding: 0 10px;
}

.doc-times {
  display: flex;
  align-items: center;
}

.doc-times input {
  font-weight: bold;
  background: rgb(255 255 255 / 10%);
  border: 1px solid rgb(255 255 255 / 50%);
  padding: 0.5rem 0;
  border-radius: 4px;
  color: #ffffff;
  width: 80px;
  text-align: center;
  transition: 0.15s background-color, 0.15s color;
}

.doc-times input:focus {
  background: #ffffff;
  color: var(--dark-blue) !important;
  box-shadow: 0 2px 5px -1px rgb(50 50 93 / 25%), 0 1px 3px -1px rgb(0 0 0 / 30%);
  font-size: 16px;
}

.doc-times__time:nth-child(1) {
  margin-right: 0.5rem;
}

.doc-times__time:nth-child(2) {
  margin-left: 0.5rem;
  margin-right: 1rem;
}

.doc-times .timepicker-line {
  padding: 0 0.5rem;
}
</style>



// WEBPACK FOOTER //
// TimeChanger.vue?eb86fa8a